import React, { createContext, useContext, useState, useCallback } from 'react';

interface IHelpContext {
  helpMode: boolean;
  toggleHelpMode: () => void;
  manualOpen: boolean;
  openManual: () => void;
  closeManual: () => void;
}

const HelpContext = createContext<IHelpContext>({
  helpMode: false,
  toggleHelpMode: () => {},
  manualOpen: false,
  openManual: () => {},
  closeManual: () => {},
});

export const HelpProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [helpMode, setHelpMode] = useState(false);
  const [manualOpen, setManualOpen] = useState(false);

  const toggleHelpMode = useCallback(() => setHelpMode(prev => !prev), []);
  const openManual = useCallback(() => setManualOpen(true), []);
  const closeManual = useCallback(() => setManualOpen(false), []);

  return (
    <HelpContext.Provider value={{ helpMode, toggleHelpMode, manualOpen, openManual, closeManual }}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = () => useContext(HelpContext);
